import internalIndex from "@/views/internal/Index.vue";
import Home from "@/views/pages/Home/home.vue";

const HomeRoutes = {
  component: internalIndex,
  children: [
    {
      path: "",
      name: "home",
      component: Home,
      meta: {},
    },

    { path: "*", redirect: "/" },
  ],
};

export default HomeRoutes;
